var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-course-layout',{attrs:{"title":"ساخت دوره","submitFunction":_vm.createCourse}})
}
var staticRenderFns = []

export { render, staticRenderFns }